import React from "react";
import classes from "./HeaderPopup.module.css"

const HeaderPopup = ({ title, children, className, accessibilityDescription }) => {

    return (
        // <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={() => console.log('close')}>
        <>
            <div className={`${classes.HeaderPopup} ${className}`} >
                <div>{title}</div>
                {children && children}
                {/* <button style={{ width: 0, height: 0, opacity: 0 }} tabIndex={0}></button> */}
            </div>
        </>
        // </AccessibilityPopup>
    )
}

export default HeaderPopup;